"use client";

import React from "react";

// Map loading placeholder for SSR
function MapPlaceholder({ mapheight = 300 }) {
  return (
    <div
      style={{
        height: mapheight,
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f0f0f0",
        border: "1px solid #ddd",
      }}
    >
      <div>Loading map...</div>
    </div>
  );
}

class MapWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      MapComponent: null,
      isClient: false,
      googleLoaded: false,
    };
    this.checkGoogleMapsInterval = null;
  }

  injectGoogleScript = () => {
    if (document.getElementById("google-maps-script")) return;

    const script = document.createElement("script");
    script.id = "google-maps-script";
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.NEXT_PUBLIC_GOOGLE_API}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      this.setState({ googleLoaded: true }, () => this.loadMapComponent());
    };
    document.body.appendChild(script);
  };

  checkGoogleMapsLoaded = () => {
    if (typeof window !== "undefined" && window.google && window.google.maps) {
      this.setState({ googleLoaded: true }, () => this.loadMapComponent());
      if (this.checkGoogleMapsInterval) {
        clearInterval(this.checkGoogleMapsInterval);
        this.checkGoogleMapsInterval = null;
      }
    }
  };

  loadMapComponent = () => {
    if (this.state.googleLoaded && !this.state.MapComponent) {
      import("./ModernMapComponent")
        .then((module) => {
          this.setState({ MapComponent: module.default });
        })
        .catch((error) => {
          console.error("Error loading map component:", error);
        });
    }
  };

  componentDidMount() {
    this.setState({ isClient: true });

    // Check if Google Maps is already loaded (from global script)
    if (typeof window !== "undefined" && window.google && window.google.maps) {
      this.setState({ googleLoaded: true }, () => this.loadMapComponent());
    } else {
      // Wait for Google Maps to load from global script
      // Don't inject script again to avoid duplicate loading
      this.checkGoogleMapsInterval = setInterval(
        this.checkGoogleMapsLoaded,
        200,
      );
    }
  }

  componentWillUnmount() {
    if (this.checkGoogleMapsInterval) {
      clearInterval(this.checkGoogleMapsInterval);
    }
  }

  render() {
    const {
      poly_data,
      nhdetails,
      showmarkers,
      npiscore,
      npirank,
      nhname,
      lat,
      lng,
      homes,
      mapheight = 250,
    } = this.props;

    const { MapComponent, isClient, googleLoaded } = this.state;

    if (!isClient || !googleLoaded || !MapComponent) {
      return <MapPlaceholder mapheight={mapheight} />;
    }

    return (
      <div style={{ height: mapheight, width: "100%" }}>
        <MapComponent
          poly_data={poly_data}
          nhdetails={nhdetails}
          showmarkers={showmarkers}
          npiscore={npiscore}
          npirank={npirank}
          nhname={nhname}
          lat={lat}
          lng={lng}
          homes={homes}
        />
      </div>
    );
  }
}

export default MapWrapper;
